import React, { useState } from "react";
import { FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";
import { Tooltip } from "@mui/material";

const SocialMediaIcons = ({ platform, phoneNumber, username }) => {
  const [openedTabs, setOpenedTabs] = useState({});

  // Handle WhatsApp opening with app or fallback to web
  const openWhatsApp = () => {
    if (!phoneNumber) return;

    const formattedPhoneNumber =
      phoneNumber.length === 10 ? `91${phoneNumber}` : phoneNumber;

    const appUrl = `whatsapp://send?phone=${formattedPhoneNumber}`;
    const webUrl = `https://api.whatsapp.com/send/?phone=%2B${formattedPhoneNumber}`;

    let opened = false;

    // Create an invisible iframe to try opening the app without triggering the fallback
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appUrl;
    document.body.appendChild(iframe);

    // If the app opens, the window will lose focus; prevent the fallback
    window.addEventListener("blur", () => {
      opened = true;
    });

    // Fallback to web if app fails to open
    setTimeout(() => {
      if (!opened) {
        window.open(webUrl, "_blank");
      }
      document.body.removeChild(iframe);
    }, 1000);
  };

  // Define platform-specific URLs
  const platformUrls = {
    instagram: username && `https://www.instagram.com/${username}`,
    youtube: username && `https://www.youtube.com/@${username}`,
  };

  // Select the appropriate icon
  const platformIcons = {
    whatsapp: <FaWhatsapp size={20} color="green" />,
    instagram: <FaInstagram size={20} color="purple" />,
    youtube: <FaYoutube size={20} color="red" />,
  };

  // Handle click event for non-WhatsApp platforms
  const handleClick = () => {
    if (platform === "whatsapp") {
      openWhatsApp();
      return;
    }

    const url = platformUrls[platform];
    if (!url) return;

    // Check if the tab is already open
    if (openedTabs[platform]) {
      if (openedTabs[platform].closed) {
        // Tab was closed manually, so remove from state
        setOpenedTabs((prevTabs) => {
          const updatedTabs = { ...prevTabs };
          delete updatedTabs[platform];
          return updatedTabs;
        });
      } else {
        // Close the tab before opening a new one
        openedTabs[platform].close();
      }
    }

    // Open a new tab and store the reference
    const newTab = window.open(url, "_blank");
    setOpenedTabs((prevTabs) => ({ ...prevTabs, [platform]: newTab }));
  };

  return (
    <>
      <Tooltip placement="bottom" title="Open Whatsapp">
        <div onClick={handleClick} style={{ cursor: "pointer" }}>
          {platformIcons[platform] || null}
        </div>
      </Tooltip>
    </>
  );
};

export default SocialMediaIcons;
